module.exports = __webpack_public_path__ + "static/media/phone.9d5e275e.gif";